/* eslint-disable import/prefer-default-export */
import { RightRailFlexArticles } from 'components/Ad/AdSlot';
import { AdvSearchGrid } from './AdvancedSearchPageStyling';

const AdvancedSearchPage: React.FC = () => (
  <AdvSearchGrid>
    <div id='queryly_advanced_container'>
      <div id='faceteddata' />
      <div id='resultdata' />
    </div>
    <RightRailFlexArticles id={1} />
  </AdvSearchGrid>
);

export { AdvancedSearchPage };
